export function getEndOfTomorrow() {
  const now = new Date();

  const tomorrow = new Date(now);

  tomorrow.setDate(now.getDate() + 1);

  const endOfTomorrow = new Date(tomorrow);

  endOfTomorrow.setHours(23, 59, 59, 999);

  return endOfTomorrow;
}
